import { KeyboardEvent, MouseEvent, ReactNode } from "react";

interface IconClickableProps {
  className?: string;
  onClick: (e: MouseEvent | KeyboardEvent) => void;
  testId?: string;
  ariaLabel?: string;
  children: ReactNode;
}

/**
 * Keyboard-accessible click target for the lineage canvas controls
 * (expand/collapse handles, expansion arrows). Renders a div styled like the
 * surrounding controls but with button semantics so it satisfies a11y rules.
 * Pass `ariaLabel` to give the button an accessible name (also lets tests use
 * semantic `getByRole("button", { name })` queries).
 */
const IconClickable = ({ className, onClick, testId, ariaLabel, children }: IconClickableProps) => (
  <div
    role="button"
    tabIndex={0}
    aria-label={ariaLabel}
    className={className}
    onClick={onClick}
    onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick(e);
      }
    }}
    data-testid={testId}
  >
    {children}
  </div>
);

export default IconClickable;
